<!-- 我的简历 -->
<template>
  <div class="resume">
    <!-- 导航栏 -->
    <van-nav-bar
      :title="`${userinfo.name}的简历`"
      fixed
      placeholder
      z-index="100"
      @click-left="onClickLeft"
    >
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
    </van-nav-bar>

    <div class="resume-box">
      <!-- 个人简历-->
      <div class="resume-user">
        <div class="user-info">
          <span class="user-name">{{userinfo.name}}{{userinfo.sex==1?'（先生）':'（女士）'}}</span>
          <div class="info-item">
            <span>{{age}}岁</span>
            <span v-if="userinfo.education_name!=''">{{userinfo.education_name}}</span>
            <span v-if="userinfo.soldier_type_name!=''">{{userinfo.soldier_type_name}}</span>
          </div>
        </div>
        <img :src="userinfo.avatar" class="user-img" />
      </div>
      <!--  求职意向 -->
      <div class="resume-intention">
        <span>求职意向</span>
        <span style="font-size:0.24rem">{{userinfo.apply_status}}</span>
      </div>
      <!-- 职位列表 -->
      <div class="resume-list" v-for="(item, index) in intentList" :key="index">
        <div class="resume-request">
          <span>{{item.job_cn}} {{item.wage_cn}}</span>
          <span>{{item.district_cn}}</span>
        </div>
      </div>
      <!-- 工作经历 -->
      <div class="resume-intention">
        <span>工作经历</span>
      </div>
      <!-- 工作经历列表 -->
      <div>
        <div class="resume-express" v-for="(item, index) in workList" :key="index">
          <div class="express-top">
            <p>{{item.company}}</p>
            <div class="top-time">
              <span>{{item.start_time}} - {{item.end_time==''?'至今':item.end_time}}</span>
            </div>
          </div>
          <p class="express-position">{{item.jobs}}</p>
          <p class="express-content">{{item.description}}</p>
        </div>
      </div>
      <!-- 教育经历 -->
      <div class="resume-intention">
        <span>教育经历</span>
      </div>
      <!-- 教育经历列表 -->
      <div>
        <div class="resume-express" v-for="(item, index) in educationList" :key="index">
          <div class="express-top">
            <p>{{item.school}}</p>
            <div class="top-time">
              <span>{{item.start_time}} - {{item.end_time==''?'至今':item.end_time}}</span>
            </div>
          </div>
          <div class="express-position">
            {{item.speciality}}
            <span>·</span>
            {{item.education_name}}
          </div>
        </div>
      </div>
      <!--  个人优势 -->
      <div class="resume-intention">
        <span>个人优势</span>
      </div>
      <div class="resume-advantage">{{userinfo.description}}</div>
    </div>
    <!-- 按钮 -->
    <div class="btns" v-show="type==0">
      <div class="boss-btn">
        <div class="boss-tel" @click="telPhone">
          <img src="@/assets/img/home/tel.png" class="back" />
          <span>电话</span>
        </div>

        <button @click="confirm" style="margin-left:0">邀请面试</button>
      </div>
    </div>
    <!-- 面试时间弹窗 -->
    <!-- <van-popup v-model="show" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        title="选择面试时间"
        :min-date="minDate"
        :max-date="maxDate"
        :filter="filter"
        @confirm="confirm"
        @cancel="show=false"
      />
    </van-popup>-->
  </div>
</template>
<script>
import { Toast, Dialog } from "vant";
import getFormat from "@/until/getFormatDate";
import { resumeDetails, refuseInterview, remouseInvite } from "@/api/apiData";
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      id: "",
      show: false,
      userinfo: "",
      age: "", //年龄
      workList: [],
      intentList: [],
      educationList: [],
      minDate: "",
      maxDate: "",
      Y: "", //当前年份
      currentDate: new Date(),
      type: 0
    };
  },
  computed: {
    ...mapState(["token"])
  },
  methods: {
    onClickLeft() {
      this.$router.back();
    },

    // 公司端入口
    getDetails() {
      var that = this;
      var Y = that.Y;
      var obj = {
        resume_id: that.id
      };

      resumeDetails(obj).then(res => {
       //(res);
        if (res.code == 1) {
          that.userinfo = res.data.userinfo; //个人信息
          that.workList = res.data.work_list; //工作列表
          that.intentList = res.data.intent_list; //求职意向列表
          that.educationList = res.data.education_list; //教育经历列表
          var birthday = res.data.userinfo.birthday;
          var y = birthday.substring(0, birthday.indexOf("-"));
          that.age = Y - Number(y) + 1;
        }
      });
    },
    // 分钟过滤
    filter(type, options) {
      if (type === "minute") {
        return options.filter(option => option % 5 === 0);
      }
      return options;
    },
    // 选定面试时间
    confirm() {
      var that = this;
      that.show = false;
      // var date = getFormat(e, "yy-mm-ss-hh");
      Dialog.confirm({
        title: "面试邀请",
        message: "确定发送面试邀请吗？"
      })
        .then(() => {
          let obj = {
            token: that.token,
            resume_id: that.id
            // job_apply_id: that.id,
            // date: date
          };
          remouseInvite(obj).then(res => {
            if (res.code == 1) {
              Toast.success({
                message: "邀请已发送",
                forbidClick: true
              });
              setTimeout(() => {
                that.$router.back();
              }, 2000);
            } else {
              setTimeout(() => {
                Toast(res.msg);
              }, 500);
            }
          });
        })
        .catch(() => {});
    },
    // 不合适
    notFit() {
      var that = this;
      var id = that.id;
      var obj = {
        job_apply_id: id
      };
      refuseInterview(obj).then(res => {
        if (res.code == 1) {
          Toast("通知已发送");
        } else {
          Toast(res.msg);
        }
      });
    },
    //拨打电话
    telPhone() {
      window.location.href = `tel:${this.userinfo.mobile}`;
    }
  },
  created() {
    // 判断入口
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    // 获取当前时间
    var Y = new Date().getFullYear();
    this.minDate = new Date(Y, 0, 1);
    this.maxDate = new Date(Y, 11, 1);
    this.Y = Y;
  },
  mounted() {
    this.getDetails();
  }
};
</script>
<style lang='less' scoped>
.resume-box {
  padding: 0 0.32rem;
  //   个人信息
  .resume-user {
    padding: 0.4rem 0;
    display: flex;
    justify-content: space-between;
    .user-info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .user-name {
        font-size: 0.48rem;
        font-weight: bold;
        line-height: 0.67rem;
        color: #333333;
        text-align: left;
      }
      .info-item {
        display: flex;
        align-items: center;
        margin-top: 0.1rem;
        span {
          display: flex;
          align-items: center;
          font-size: 0.26rem;
          font-weight: 400;
          color: #4d4d4d;
        }
        span::after {
          content: "";
          width: 0.02rem;
          height: 0.26rem;
          display: block;
          background: #4d4d4d;
          margin: 0 0.2rem;
        }
        span:last-child::after {
          display: none;
        }
      }
    }
    .user-img {
      width: 1.4rem;
      height: 1.4rem;
      font-size: 0.2rem;
      border-radius: 50%;
    }
  }
  // 加密
  .resume-encrypt {
    // margin-top: 0.2rem;
    padding: 0.23rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .encrypt-left,
    .encrypt-right {
      flex: 1;
      display: flex;
      align-items: center;
      padding: 0.23rem 0;
      span {
        font-size: 0.32rem;
        font-weight: bold;
        line-height: 0.45rem;
        color: rgba(51, 51, 51, 1);
      }
      .left-tips {
        width: 0.32rem;
        height: 0.32rem;
        border-radius: 50%;
      }
    }

    /deep/.van-radio-group {
      display: flex;

      .van-radio {
        flex: 1;
        display: flex;
        align-items: center;
        .img-icon {
          width: 0.4rem;
          height: 0.4rem;
        }
        .van-radio__label {
          font-size: 0.3rem;
          line-height: 0.42rem;
          color: #cccccc;
        }
        .checked {
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
  }
  //   求职意向
  .resume-intention {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.23rem 0;
    margin-top: 0.2rem;
    span {
      font-size: 0.32rem;
      font-weight: bold;
      line-height: 0.45rem;
      color: rgba(51, 51, 51, 1);
    }
    // .add-img {
    //   width: 0.3rem;
    //   height: 0.3rem;
    // }
  }
  //   职位列表
  .resume-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.2rem 0;
    .resume-request {
      span {
        display: block;
        font-size: 0.28rem;
        font-weight: bold;
        line-height: 0.4rem;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 0.1rem;
      }
      span:last-child {
        font-size: 0.26rem;
        font-weight: 400;
        line-height: 0.37rem;
        color: rgba(102, 102, 102, 1);
        text-align: left;
      }
    }
  }
  // 工作经历列表
  .resume-express {
    padding: 0.2rem 0;
    font-size: 0.26rem;
    .express-top {
      display: flex;
      p {
        text-align: left;
        flex: 1.2;
        color: #333333;
        font-size: 0.28rem;
        font-weight: bold;
        line-height: 0.4rem;
        color: rgba(51, 51, 51, 1);
      }
      .top-time {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        span {
          display: inline;
          font-size: 0.24rem;
          font-weight: 400;
          line-height: 0.4rem;
          color: rgba(179, 179, 179, 1);
        }
      }
    }
    .express-position {
      display: flex;
      font-size: 0.26rem;
      font-weight: 400;
      line-height: 0.4rem;
      color: rgba(102, 102, 102, 1);
      text-align: left;
      margin: 0.12rem 0 !important;
      span {
        font-size: 1rem;
      }
    }
    .express-content {
      font-weight: 400;
      line-height: 0.4rem;
      color: rgba(102, 102, 102, 1);
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
  // 个人优势
  .resume-advantage {
    text-align: left;
    font-size: 0.26rem;
    font-weight: 400;
    line-height: 0.4rem;
    color: rgba(102, 102, 102, 1);
    margin-bottom: 1.5rem;
  }
}
.btns {
  .boss-btn {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    display: flex;
    justify-content: space-between;
    padding: 0.26rem 0.32rem;
    background: #fff;
    box-shadow: 0px -1px 0px rgba(0, 0, 0, 0.08);
    .boss-tel {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 0.2rem;
      font-weight: 400;
      line-height: 0.28rem;
      color: rgba(128, 128, 128, 1);
      flex: 1;
      span {
        margin-top: 0.1rem;
      }
    }
    .not-btns {
      flex: 3;
      background: rgba(247, 247, 247, 1);
      color: rgba(102, 102, 102, 1);
    }
    button {
      flex: 6;
      background: #ff4343;
      box-shadow: 0px -0.01rem 0px rgba(0, 0, 0, 0.08);
      font-weight: 400;
      line-height: 0.4rem;
      color: rgba(255, 255, 255, 1);
      letter-spacing: 0.1rem;
      font-size: 0.28rem;
      border-radius: 0.08rem;
      padding: 0.2rem 0;
      margin-left: 5%;
    }
  }
}
.btns::before {
  content: "";
  display: block;
  height: 1.5rem;
  width: 100%;
}
</style>